export default __webpack_public_path__ + "static/media/Tutorial1Mobile.a24f4ad5.png";